let persistPlacementsFromEditor = null;

export function registerPlacementPersister(fn) {
  persistPlacementsFromEditor = typeof fn === 'function' ? fn : null;
}

export function unregisterPlacementPersister() {
  persistPlacementsFromEditor = null;
}

/** Flush current pin placements to the server (call after pin drag drop). */
export function flushBoardPlacements() {
  if (typeof persistPlacementsFromEditor !== 'function') {
    console.warn('[board] placement persister not registered — pin move not saved');
    return;
  }
  persistPlacementsFromEditor();
}
